(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mattise-brillenkoordjes"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.currentScript ? document.currentScript.closest('.mc') : document.querySelector('.mc');
  if (!root) root = document.querySelector('.mc');
  if (!root) return;

  var grid = root.querySelector('#mc-grid');
  var cards = Array.prototype.slice.call(root.querySelectorAll('.product-card'));
  var countEl = root.querySelector('#mc-count');
  var emptyEl = root.querySelector('#mc-empty');
  var stateEl = root.querySelector('#mc-state');
  var activeModel = 'alles';
  var activeColor = null;
  var activeSort = 'rec';

  // De filters zitten achter een uitklap, dus de dichte regel moet tonen wat er aan staat.
  function refreshState() {
    if (!stateEl) return;
    var delen = [];
    if (activeModel !== 'alles') {
      var actief = root.querySelector('.tag[data-model="' + activeModel + '"]');
      delen.push(actief ? actief.textContent.trim() : activeModel);
    }
    if (activeColor) {
      var sw = root.querySelector('.swatch-filter[data-colorfilter="' + activeColor + '"]');
      if (sw) delen.push((sw.getAttribute('aria-label') || '').toLowerCase());
    }
    if (activeSort !== 'rec' && sortEl) delen.push(sortEl.options[sortEl.selectedIndex].textContent.trim().toLowerCase());
    var knop = stateEl.parentNode;
    if (delen.length) {
      stateEl.textContent = delen.join(' · ');
      if (knop) knop.setAttribute('data-actief', '');
    } else {
      stateEl.textContent = 'Filter en sorteer';
      if (knop) knop.removeAttribute('data-actief');
    }
  }

  // Leesblok open- en dichtklappen.
  var leesBlok = root.querySelector('[data-lees]');
  var leesKnop = root.querySelector('[data-leesknop]');
  if (leesBlok && leesKnop) {
    // Past de tekst sowieso binnen drie regels, dan is de knop overbodig.
    if (leesBlok.scrollHeight <= leesBlok.clientHeight + 2) {
      leesKnop.hidden = true;
      var f = leesBlok.querySelector('.m26b__fade');
      if (f) f.style.display = 'none';
    }
    leesKnop.addEventListener('click', function () {
      var open = leesBlok.hasAttribute('data-open');
      if (open) { leesBlok.removeAttribute('data-open'); } else { leesBlok.setAttribute('data-open', ''); }
      leesKnop.textContent = open ? 'Lees meer' : 'Lees minder';
      leesKnop.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  // De balk opent het filterpaneel eronder.
  root.querySelectorAll('.m26b__baritem').forEach(function (knop) {
    knop.addEventListener('click', function () {
      var stondOpen = knop.getAttribute('aria-expanded') === 'true';
      root.querySelectorAll('.m26b__baritem').forEach(function (k) {
        k.setAttribute('aria-expanded', 'false');
        var p = root.querySelector('#' + k.getAttribute('aria-controls'));
        if (p) p.hidden = true;
      });
      if (!stondOpen) {
        knop.setAttribute('aria-expanded', 'true');
        var eigen = root.querySelector('#' + knop.getAttribute('aria-controls'));
        if (eigen) eigen.hidden = false;
      }
    });
  });

  function applyColorToCard(card, key) {
    var sw = card.querySelector('.swatch[data-color="' + key + '"]');
    if (!sw) return;
    card.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('swatch--active'); });
    sw.classList.add('swatch--active');
    var name = card.querySelector('[data-colorname]');
    if (name) {
      name.textContent = sw.getAttribute('data-name') || '';
      name.className = 'metallic-' + key;
      name.setAttribute('data-colorname', '');
    }
    var img = card.querySelector('.product-card__img');
    var src = sw.getAttribute('data-image');
    if (img && src) { img.src = src; img.removeAttribute('data-empty'); }
  }

  // per-card swatch clicks
  cards.forEach(function (card) {
    card.querySelectorAll('.swatch').forEach(function (sw) {
      sw.addEventListener('click', function () { applyColorToCard(card, sw.getAttribute('data-color')); });
    });
  });

  var woordEl = root.querySelector('#mc-count-woord');
  function refreshCount() {
    var n = cards.filter(function (c) { return c.style.display !== 'none'; }).length;
    if (countEl) countEl.textContent = n;
    if (woordEl) woordEl.textContent = n === 1 ? 'product' : 'producten';
    if (emptyEl) emptyEl.hidden = n !== 0;
  }

  // model filter
  root.querySelectorAll('.tag[data-model]').forEach(function (tag) {
    tag.addEventListener('click', function () {
      root.querySelectorAll('.tag[data-model]').forEach(function (t) { t.classList.remove('tag--active'); });
      tag.classList.add('tag--active');
      activeModel = tag.getAttribute('data-model');
      cards.forEach(function (c) {
        c.style.display = (activeModel === 'alles' || c.getAttribute('data-model') === activeModel) ? '' : 'none';
      });
      refreshCount();
      refreshState();
    });
  });

  // Kleurkeuze: filtert niets weg, maar zet alle zichtbare kaarten in één kleur.
  function zichtbareKaarten() {
    return cards.filter(function (c) { return c.style.display !== 'none'; });
  }
  function zetKleur(key) {
    zichtbareKaarten().forEach(function (c) { applyColorToCard(c, key); });
  }
  function kleurTerug() {
    zichtbareKaarten().forEach(function (c) {
      var first = c.querySelector('.swatch');
      if (first) applyColorToCard(c, first.getAttribute('data-color'));
    });
  }
  root.querySelectorAll('.swatch-filter').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-colorfilter');
      var wasActive = btn.classList.contains('is-active');
      root.querySelectorAll('.swatch-filter').forEach(function (b) { b.classList.remove('is-active'); });
      if (wasActive) {
        // Nogmaals klikken zet de kaarten ook echt terug, anders liep de knopstand
        // uit de pas met wat je ziet.
        activeColor = null;
        kleurTerug();
      } else {
        btn.classList.add('is-active');
        activeColor = key;
        zetKleur(key);
      }
      refreshState();
    });
  });

  // Reset zet alles terug: model, kleur en sortering. Deed eerder alleen de kleur.
  var resetBtn = root.querySelector('#mc-reset');
  if (resetBtn) resetBtn.addEventListener('click', function () {
    root.querySelectorAll('.tag[data-model]').forEach(function (t) { t.classList.remove('tag--active'); });
    var alles = root.querySelector('.tag[data-model="alles"]');
    if (alles) alles.classList.add('tag--active');
    activeModel = 'alles';
    cards.forEach(function (c) { c.style.display = ''; });

    root.querySelectorAll('.swatch-filter').forEach(function (b) { b.classList.remove('is-active'); });
    activeColor = null;
    kleurTerug();

    if (sortEl) { sortEl.value = 'rec'; activeSort = 'rec'; herschik(); }

    refreshCount();
    refreshState();
  });

  // sort
  var sortEl = root.querySelector('#mc-sort');
  function herschik() {
    if (!grid) return;
    var v = activeSort;
    var sorted = cards.slice().sort(function (a, b) {
      if (v === 'price-asc') return (+a.dataset.price) - (+b.dataset.price);
      if (v === 'price-desc') return (+b.dataset.price) - (+a.dataset.price);
      if (v === 'name') return (a.dataset.name || '').localeCompare(b.dataset.name || '');
      return 0;
    });
    sorted.forEach(function (c) { grid.appendChild(c); });
  }
  if (sortEl && grid) sortEl.addEventListener('change', function () {
    activeSort = sortEl.value;
    herschik();
    refreshState();
  });
})();

  // Beeld-fallback voor ontbrekende modelfoto's: vrouw-ingezoomd -> man-ingezoomd -> lay-flat productfoto.
  // 'error' bubbelt niet, dus capture-fase op document.
  document.addEventListener('error', function (e) {
    var img = e.target;
    if (!img || img.tagName !== 'IMG' || !img.classList || !img.classList.contains('product-card__img')) return;
    var s = img.getAttribute('src') || '';
    if (s.indexOf('-vrouw-ingezoomd') > -1) {
      img.setAttribute('src', s.replace('-vrouw-ingezoomd', '-man-ingezoomd'));
    } else if (s.indexOf('-man-ingezoomd') > -1) {
      img.setAttribute('src', s.replace(/\/model-(.+?)-(goud|zilver|rose-goud|zwart)-man-ingezoomd\.jpg/, '/productfoto-$1-$2.jpg'));
    }
  }, true);

  } catch(e) { console.error(e); }
})();
})();
